import ButtonSelect from "./common/ButtonSelect";


export const DisplayWidget = ButtonSelect.withOptions([
	{value: 'block', label: 'Block'},
	{value: 'inline-block', label: 'Inline-Block'},
	{value: 'inline', label: 'Inline'}
]);

export const FloatWidget = ButtonSelect.withOptions([
	{value: 'none', label: 'None'},
	{value: 'left', label: 'Left'},
	{value: 'right', label: 'Right'}
]);

export const ClearWidget = ButtonSelect.withOptions([
	{value: 'none', label: 'None'},
	{value: 'left', label: 'Left'},
	{value: 'right', label: 'Right'},
	{value: 'both', label: 'Both'}
]);

export const TextAlignWidget = ButtonSelect.withOptions([
	{value: 'left', label: 'Left'},
	{value: 'center', label: 'Center'},
	{value: 'right', label: 'Right'}
]);



// WEBPACK FOOTER //
// ./src/common/form/widgets/BlockWidgets.tsx